import React from 'react';
import './text-with-icon.scss'

const TextWithIcon = ({text, src, img}) => (
    <div className="text-with-icon">
        {src && (
            <img className="me-2" src={src} />
        )}
        {img}
        {text}
    </div>
);
export default TextWithIcon;
